/**
 * General Settings card for the SFTP Push tab. Edits the resubmit filename prefix
 * and the list of CMM statuses considered valid during validation. These fields
 * are not shown in the design mockup but are part of the document, so they are
 * surfaced here to keep the whole config editable from the dashboard.
 */
import { TextInput } from "risa-oasis-ui_v2";
import MultiSelectWithTag from "../../../../../components/multiSelectWithTag/MultiSelectWithTag";

const CMM_STATUS_OPTIONS = [
  "completed",
  "invalid_key",
  "success",
  "failed",
].map((s) => ({ id: s, label: s }));

interface GeneralSettingsCardProps {
  filenamePrefix: string;
  validCmmStatuses: string[];
  onFilenamePrefixChange: (value: string) => void;
  onValidCmmStatusesChange: (values: string[]) => void;
}

const GeneralSettingsCard = ({
  filenamePrefix,
  validCmmStatuses,
  onFilenamePrefixChange,
  onValidCmmStatusesChange,
}: GeneralSettingsCardProps) => (
  <div className="flex flex-col gap-3 rounded-lg border border-primaryGray-16 p-4">
    <div className="text-sm font-semibold text-primaryGray-1">
      General Settings
    </div>
    <div className="flex flex-row flex-wrap gap-4">
      <div className="min-w-[18rem] flex-1">
        <TextInput
          id="sftp-filename-prefix"
          label="Resubmit Filename Prefix"
          placeholder="NYCBS_RXSM_RisaHealth_pending_response_"
          defaultValue={filenamePrefix}
          onChange={(data: { value?: string }) =>
            onFilenamePrefixChange(data.value ?? "")
          }
          onBlur={(data: { value?: string }) =>
            onFilenamePrefixChange(data.value ?? "")
          }
        />
      </div>
      <div className="min-w-[18rem] flex-1">
        <div className="mb-1 text-tiny font-medium text-primaryGray-3">
          Valid CMM Statuses
        </div>
        <MultiSelectWithTag
          options={CMM_STATUS_OPTIONS}
          value={validCmmStatuses}
          onChange={onValidCmmStatusesChange}
          placeholder="Select statuses..."
          dropdownWidth="14rem"
        />
      </div>
    </div>
  </div>
);

export default GeneralSettingsCard;
